module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/what-is-vux-virtual-component-50.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/faq/what-is-vux-virtual-component.md
// module id = 751
// module chunks = 188